import axios from 'axios';

const walletApi = axios.create({
	baseURL: '/api/wallet/v1',
	withCredentials: true,
});

export default walletApi;
